import { render, staticRenderFns } from "./ConfirmInvitation.vue?vue&type=template&id=7bd421a8"
import script from "./ConfirmInvitation.vue?vue&type=script&lang=js"
export * from "./ConfirmInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports